import React from 'react';
import { getSocialImage } from '../../scripts/media';

interface Props {
  children?: any;
  title: string;
  description?: string;
  noindex?: boolean;
  socialImage?: string;
}
function SEO({ title, description, noindex, socialImage, children }: Props) {
  return (
    <>
      <title>{title}</title>
      {description && (
        <>
          <meta
            name="description"
            content={description}
          />
          <meta
            property="og:description"
            content={description}
          />
          <meta
            name="twitter:description"
            content={description}
          />
        </>
      )}
      <meta
        property="og:image"
        content={getSocialImage(socialImage || '')}
      />
      <meta
        name="twitter:image"
        content={getSocialImage(socialImage || '')}
      />
      <meta
        name="twitter:title"
        content={title}
      />
      <meta
        property="og:title"
        content={title}
      />
      <meta
        property="og:url"
        content="https://www.experian.com/credit/credit-monitoring/"
      />
      {noindex && (
        <meta
          name="robots"
          content="noindex"
        />
      )}
      {children}
    </>
  );
}

export default SEO;
